import React from 'react'
import PropTypes from 'prop-types'
import QueryManager from './Query'
import gql from 'graphql-tag'
import { get } from 'lodash'

const QUERY_GET_ASSIGN_INFO = gql`query getAssignmentInfo($id: String!) {
  getAssignmentInfo(id: $id) {
    user {
      firstName
      lastName
      document
      email
      status
      id
    }
    order {
      id
      status
      assignedAt
    }
  }
}`

const AssignInfo = ({ children, ...props }) => {
  return (
    <QueryManager query={QUERY_GET_ASSIGN_INFO} {...props}>
      {({ data, loading, fetchMore, refetch }) =>
        children({
          data: get(data, 'getAssignmentInfo', {}),
          refetch,
          loading,
          fetchMore: ({ pageSize }) => fetchMore({
            query: QUERY_GET_ASSIGN_INFO,
            variables: { },
            updateQuery: () => (null)
          })
        })}
    </QueryManager>
  )
}

AssignInfo.propTypes = {
  children: PropTypes.any
}

export default AssignInfo
